import { readBlackListFile } from '@/utils/api';
import { parseBlackList } from '@/utils/data_parse';

export default {
  namespaced: true,
  state: {
    allList: [], // 用于搜索
    list: [], // 用于渲染
  },
  mutations: {
    save(state, payload) {
      Object.assign(state, payload);
    },
  },
  actions: {
    async getBlackList({ commit }) {
      const res = await readBlackListFile();
      if (res.status === 200) {
        const fileData = parseBlackList(res.data);
        commit('save', {
          list: fileData,
          allList: fileData,
        });
      }
    },
  },
};
